import { CONSTANTS, ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './conversion-rate-adjustment.pug';

export class ConversionRateColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n,
    inlineEditConfig: {
      onEditRate,
    } = {},
  }) {
    const title = _TL_('Conversion rate adjustment');
    super({
      name: 'AdjustmentPercentage',
      title,
      i18n,
      property: 'AdjustmentPercentage',
      sortable: 'AdjustmentPercentage',
      type: CONSTANTS.COLUMN_TYPES.NUMBER,
      format: CONSTANTS.COLUMN_FORMATS.PERCENTAGE_VALUE,
      helpId: 'pop_BA_SeasonalityAdjustments_ConversionRate',
      helpAriaLabel: i18n.getString(_TL_('Click to learn more about {{item}}'), { item: i18n.getString(title) }),
    });
    this.onEditRate = onEditRate;
    this.i18n = i18n;
  }

  template({ value }) {
    let multiplier = '';
    const formattedValue = this.formatter(Math.abs(value));
    if (value < 0) {
      multiplier = `-${formattedValue}`;
    } else {
      multiplier = `+${formattedValue}`;
    }
    return template({
      conversionRate: multiplier,
      i18n: this.i18n,
    });
  }

  onPrompt(...args) {
    /* istanbul ignore next */
    this.onEditRate(...args);
  }
}

